"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var creator_ui_1 = require("@chameleoncreator/creator-ui");
var BurgerIcon = function () {
    return (react_1.default.createElement("svg", { width: "26px", height: "16px", viewBox: "0 0 18 14", version: "1.1" },
        react_1.default.createElement("title", null, "Burger"),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("g", { fill: "#282A2B" },
                react_1.default.createElement("rect", { x: "0", y: "0", width: "18", height: "2" }),
                react_1.default.createElement("rect", { x: "0", y: "6", width: "18", height: "2" }),
                react_1.default.createElement("rect", { x: "0", y: "12", width: "18", height: "2" })))));
};
exports.Burger = function (_a) {
    var showDrawer = _a.showDrawer, setDrawer = _a.setDrawer;
    return (react_1.default.createElement(creator_ui_1.Flexbox, { flex: "0 0 52px", pl: "24px", pr: "4px", height: "70px", style: { cursor: "pointer" }, onClick: function () { return setDrawer(!showDrawer); }, justifyContent: "center", alignItems: "center" },
        react_1.default.createElement(BurgerIcon, null)));
};
